var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburgerMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 45,
    viewBox: "0 0 47 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 45,
    rx: 5,
    fill: "#017EA7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 27.9167C16 28.5159 16.4788 29 17.0714 29H29.9286C30.5212 29 31 28.5159 31 27.9167C31 27.3174 30.5212 26.8333 29.9286 26.8333H17.0714C16.4788 26.8333 16 27.3174 16 27.9167ZM16 22.5C16 23.0992 16.4788 23.5833 17.0714 23.5833H29.9286C30.5212 23.5833 31 23.0992 31 22.5C31 21.9008 30.5212 21.4167 29.9286 21.4167H17.0714C16.4788 21.4167 16 21.9008 16 22.5ZM31 17.0833C31 16.4841 30.5212 16 29.9286 16H17.0714C16.4788 16 16 16.4841 16 17.0833C16 17.6826 16.4788 18.1667 17.0714 18.1667H29.9286C30.5212 18.1667 31 17.6826 31 17.0833Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerMenu);
export default __webpack_public_path__ + "static/media/hamburgerMenu.f8cb835ca945569f3279a8ed927b91e9.svg";
export { ForwardRef as ReactComponent };